export const BACKDROP_OPACITY = 0.06;
export const BACKDROP_Z_INDEX = 1400;
export const LARGE = 'large';
export const SMALL = 'small';